import { useQuery } from "@apollo/client";
import { useEffect, useRef } from "react";
import GetClientProfileDocument from "src/api/graphql/__generated__/documents/GetClientProfileDocument";
import log from "src/helpers/log";

const useClientProfile = () => {
	const { data, refetch } = useQuery(GetClientProfileDocument, {
		returnPartialData: false,
		fetchPolicy: "cache-first",
	});
	const didRefetch = useRef(false);
	useEffect(() => {
		if (!data?.getClientProfile || Object.keys(data.getClientProfile).length === 0) {
			log.error("Empty client profile bug");
			if (!didRefetch.current) {
				refetch();
				didRefetch.current = true;
			}
		}
	}, [data, refetch]);

	return {
		profile: data?.getClientProfile,
		refetch: refetch,
	};
};
export default useClientProfile;
